<template>
  <div class="subscribe">
    <div class="subscribe-bg">
      <div class="subscribe-form">
        <van-form @submit="onSubmit">
          <label class="title1">预约试驾</label>
          <!-- 选择车型 -->
          <van-field
            readonly
            clickable
            name="motorcycleType"
            :value="car_name"
            placeholder="请选择车型"
            @click="showMotorcycleType = true"
            :rules="[{ required: true, message: '' }]"
          />
          <van-popup v-model="showMotorcycleType" position="bottom">
            <van-picker
              show-toolbar
              :columns="motorcycleTypeList"
              @confirm="motorcycleType"
              @cancel="showMotorcycleType = false"
            />
          </van-popup>
          <!-- 姓名 -->
          <van-field
            v-model="formData.true_name"
            name="name"
            placeholder="请输入姓名"
            :rules="[{ required: true, message: '' }]"
          />
          <!-- 手机号 -->
          <van-field
              v-model="formData.mobile"
              name="phone"
              placeholder="请输入手机号"
              :rules="[{ required: true, message: '' }]"
          />
          <!-- 选择经销商 -->
          <label class="title2">选择门店</label>
          <!-- 省 市 区-->
          <van-field
            readonly
            clickable
            name="area"
            :value="areaVals"
            placeholder="点击选择省市区"
            @click="showArea = true"
            :rules="[{ required: true, message: '' }]"
          />
          <van-popup v-model="showArea" position="bottom">
            <van-picker
              show-toolbar
              :columns="areaList"
              @confirm="areaVal"
              @cancel="showArea = false"
            />
          </van-popup>
          <!-- 门店 -->
          <van-field
            readonly
            clickable
            name="dealer"
            :disabled="isDisabled"
            :value="storeName"
            placeholder="请选择门店"
            @click="isDisabled?showDealer = false : showDealer = true"
            :rules="[{ required: true, message: '' }]"
          />
          <van-popup v-model="showDealer" position="bottom">
            <van-picker
              show-toolbar
              :columns="dealerList"
              @confirm="dealer"
              @cancel="showDealer = false"
            />
          </van-popup>
          <!-- 提交 -->
          <div style="margin: 16px;">
            <van-button round block type="info" class="btn" native-type="submit">即刻预约</van-button>
          </div>
        </van-form>
      </div>
    </div>
  </div>
</template>
<script>
import { modelsShowApi, getAreaListApi, getStoresApi, SubmitTestDrivesApi, idOutApi } from "@/api/api";
import { Form, Field, Picker, Popup, Area, Toast } from 'vant';
export default {
  name:'subscribe',
  components:{
    [Form.name]:Form,
    [Field.name]:Field,
    [Picker.name]:Picker,
    [Popup.name]:Popup,
    [Area.name]:Area,
  },
  data() {
    return {
      id:'', //门店id
      car_name:'',
      storeName:'',
      storeId:'',
      isDisabled:true,
      areaList:[], //省市区列表数据
      motorcycleTypeList:[], //车型列表
      dealerList: [], //门店列表
      dealerList1:[],
      showMotorcycleType: false, //车型弹窗
      showDealer:false, //经销商弹窗
      showArea: false, //省市区弹窗
      formData:{
        car_id:'', //车型
        true_name: '', //姓名
        mobile:'', //手机
        province_id: '', //省
        city_id:'', //市
        region_id:'', //区
        chain_id:'', //门店
      },
      subForm: {
        "addr": "",
        "appointment": "",
        "cx": "",
        "storeId": "",
        "storeName": "",
        "channel": ""
      },
      areaVals:'',
      labelList:[]
    };
  },
  created(){
    this.modelsShowApi()
    this.getAreaListApi()
    if (this.$route.query.chain_id) {
      this.id = this.$route.query.chain_id
      this.idOutApi()
    }
  },
  methods: {
    idOutApi(){
      const params = {
        m:'Mobile',
        a:'get_chain_by_id',
        c:'MajorProduct',
        chain_id:this.id
      }
      idOutApi(params).then(({data})=>{
        if (data.datas.list&&data.datas.list.length>0) {
          this.areaVals = data.datas.list[0].area_info
          this.province_id = data.datas.list[0].area_id_1
          this.city_id = data.datas.list[0].area_id_2
          this.formData.chain_id = data.datas.list[0].chain_id
          this.storeName = data.datas.list[0].storeName
        }
      })
    },
    // 获取车型数据
    modelsShowApi(){
      const params = {
        m:'Mobile',
        c:'MajorProduct',
        a:'get_car',
      }
      modelsShowApi(params).then(({data})=>{
        data.datas.list.forEach((item,idx) => {
          this.motorcycleTypeList.push(item.pro_name)
        });
      })
    },
    // 获取省市区
    getAreaListApi(){
      const params = {
        m:'Mobile',
        c:'Area',
        a:'get_tree_list'
      }
      getAreaListApi(params).then(({data})=>{
        data.data.forEach((item,idx) => {
          item.text = item.area_name
          item.children.forEach((item1,idx1) => {
            item1.text = item1.area_name
            item1.childrens = item1.children
            delete item1.children
          });
        });
        this.areaList = data.data
      })
    },
    // 选择车型
    motorcycleType(value){
      this.car_name = value
      const params = {
        m:'Mobile',
        c:'MajorProduct',
        a:'get_car',
      }
      modelsShowApi(params).then(({data})=>{
        data.datas.list.forEach((item,idx) => {
          if (value == item.pro_name) {
            this.formData.car_id = item.pro_name
          }
        });
      })

      this.showMotorcycleType = false
    },
    // 省市区
    areaVal(value,index) {
      this.labelList = value
      this.dealerList = []
      this.formData.chain_id = ''
      this.areaVals = value.join('-')
      this.showArea = false;
      const params = {
        m:'Mobile',
        c:'Area',
        a:'get_tree_list'
      }
      getAreaListApi(params).then(({data})=>{
        data.data.forEach((item,idx) => {
          if (item.area_name == value[0]) {
            this.formData.province_id = item.area_id
            item.children.forEach((item1,idx1) => {
              if (item1.area_name == value[1]) {
                this.formData.city_id=item1.area_id
              }
            });
          }
        });
        this.regionChange()
      })
    },
    // 根据地址查找门店
    regionChange(){
      const params = {
        condition:'',
        locations:'',
        city:this.labelList[1],
      }
      getStoresApi(params).then(({data})=>{
        this.dealerList1 = data.result
        data.result.forEach((item,idx) => {
          this.dealerList.push(item.storeName)
        })
        this.isDisabled = false
      })
    },
    // 门店
    dealer(value){
      this.storeName = value
      this.dealerList1.forEach(element => {
        if (value == element.storeName) {
          this.storeId = element.storeId
          this.subForm.linkTel = element.linkTel
          this.subForm.longitude = element.longitude
          this.subForm.latitude = element.latitude
        }
      });
      this.showDealer = false
    },
    // 提交
    onSubmit(values) {
      let currentTime = new Date()
      let year = currentTime.getFullYear()
      let month = currentTime.getMonth() + 1 < 10 ? '0' + (currentTime.getMonth() + 1) : currentTime.getMonth()+ 1
      let day = currentTime.getDate() < 10 ? '0' + currentTime.getDate() : currentTime.getDate()

      this.subForm.cx = this.formData.car_id
      this.subForm.userName = this.formData.true_name
      this.subForm.userTel = this.formData.mobile
      this.subForm.addr = this.areaVals
      this.subForm.appointment = year + '-' +month + '-' + day
      this.subForm.storeId = this.storeId
      this.subForm.storeName = this.storeName
      this.subForm.channel = '公众号'
      let obj = Object.assign({},this.subForm)
      SubmitTestDrivesApi(obj).then(({data})=>{
        if (data.code == 200) {
          for (const key in this.subForm) {
            if (Object.hasOwnProperty.call(this.subForm, key)) {
              this.subForm[key] = ''
            }
          }
          this.$toast.success('提交成功')
        }
        if (data.code == 400) {
          this.$toast.error('提交失败')
        }
      })
    },
  },
}
</script>
<style lang="scss">
@import './subscribe.scss';
</style>
